// @module Ames.RentFromAnywhere.AccessGate
// Client-side access gate for the Rent From Anywhere program (rental page
// grid + rental PDPs). Username / password are checked in the browser and the
// unlock is kept in sessionStorage, so this is a deterrent for casual visitors,
// NOT a security control: anyone reading the bundle can find the credentials.
// Rental orders themselves are not blocked server-side.
define("Ames.RentFromAnywhere.AccessGate", ["jQuery", "underscore"], function (jQuery, _) {
  "use strict";

  // Change here to rotate the credentials (redeploy + activate the extension)
  var CREDENTIALS = { username: "amesrental", password: "Rent2026!" };
  var STORAGE_KEY = "rfa_access_unlocked";
  var ENABLED = true; // set to false to open the program to everyone

  function storage() {
    try { return window.sessionStorage; } catch (e) { return null; }
  }

  function isUnlocked() {
    if (!ENABLED) return true;
    try {
      var s = storage();
      return !!(s && s.getItem(STORAGE_KEY) === "1");
    } catch (e) {
      return false;
    }
  }

  function unlock(username, password) {
    var ok = String(username || "").trim().toLowerCase() === CREDENTIALS.username.toLowerCase() &&
             String(password || "") === CREDENTIALS.password;
    if (ok) {
      try { var s = storage(); if (s) s.setItem(STORAGE_KEY, "1"); } catch (e) {}
      jQuery(document).trigger("rfa:unlocked");
    }
    return ok;
  }

  function lock() {
    try { var s = storage(); if (s) s.removeItem(STORAGE_KEY); } catch (e) {}
  }

  // Inline form (used by the grid) - returns HTML string
  function formHtml(message) {
    return '' +
      '<form class="rfa-gate" data-action="rfa-gate-form" autocomplete="off">' +
        '<div class="rfa-gate-title">Rental program access</div>' +
        '<div class="rfa-gate-text">Rent From Anywhere is currently available by invitation. Enter your access credentials to view and rent tools.</div>' +
        '<label class="rfa-gate-label">Username<input type="text" class="rfa-gate-input" name="rfa_user" autocomplete="off"></label>' +
        '<label class="rfa-gate-label">Password<input type="password" class="rfa-gate-input" name="rfa_pass" autocomplete="new-password"></label>' +
        '<div class="rfa-gate-error"' + (message ? '' : ' style="display:none"') + '>' + (message || '') + '</div>' +
        '<button type="submit" class="rfa-gate-button">Unlock</button>' +
      '</form>';
  }

  // Wire a form rendered with formHtml(): calls onSuccess() after a valid login
  function bindForm($container, onSuccess) {
    $container.off("submit.rfaGate").on("submit.rfaGate", '[data-action="rfa-gate-form"]', function (e) {
      e.preventDefault();
      var $form = jQuery(this);
      if (unlock($form.find('[name="rfa_user"]').val(), $form.find('[name="rfa_pass"]').val())) {
        if (_.isFunction(onSuccess)) onSuccess();
      } else {
        $form.find(".rfa-gate-error").text("Invalid username or password.").show();
        $form.find('[name="rfa_pass"]').val("").focus();
      }
    });
  }

  // Modal (used by the PDP notice)
  function openModal(onSuccess) {
    if (jQuery(".rfa-gate-modal").length) return;
    var $modal = jQuery(
      '<div class="rfa-gate-modal">' +
        '<div class="rfa-gate-modal-backdrop" data-action="rfa-gate-close"></div>' +
        '<div class="rfa-gate-modal-box">' +
          '<button type="button" class="rfa-gate-modal-close" data-action="rfa-gate-close" aria-label="Close">&times;</button>' +
          formHtml() +
        '</div>' +
      '</div>'
    );
    jQuery("body").append($modal);
    $modal.find('[name="rfa_user"]').focus();
    $modal.on("click", '[data-action="rfa-gate-close"]', function () { $modal.remove(); });
    bindForm($modal, function () {
      $modal.remove();
      if (_.isFunction(onSuccess)) onSuccess();
    });
  }

  return {
    isEnabled: function () { return ENABLED; },
    isUnlocked: isUnlocked,
    unlock: unlock,
    lock: lock,
    formHtml: formHtml,
    bindForm: bindForm,
    openModal: openModal
  };
});
